import { useTheme } from "styled-components";
import { useState } from "react";
import {
  Container,
  ButtonContent,
  ButtonIcon,
  ButtonWrapper,
} from "./QrCodeStyles";
import TitleStyles from "../../../components/ui/TitleStyles";
import DownIcon from "../../../img/logged/down.png";
import QrPreview from "../../../components/qr/qrPreview/QrPreview";
import ButtonGradient from "../../../components/ui/ButtonGradient";
import QrCustomizer from "../../../components/qr/qrCustomizer/QrCustomizer";

import wallpaper1 from "../../../img/logged/wallpaper/wallpaperPresskit.png";

const QrCode = () => {
  const theme = useTheme();

  const [primaryColor, setPrimaryColor] = useState(theme.THEME.white);
  const [backgroundColor, setBackgroundColor] = useState(theme.THEME.black);
  const [borderColor, setBorderColor] = useState(theme.THEME.white);

  const [selectedWallpaper, setSelectedWallpaper] = useState<
    string | undefined
  >(wallpaper1);

  const handleDownloadQrOnly = () => {
    alert("QR Code simples baixado!");
  };

  const handleDownloadWithBackground = () => {
    alert("QR Code com fundo baixado!");
  };

  return (
    <Container>
      <TitleStyles>Gerar QR Code</TitleStyles>

      <QrPreview
        primaryColor={primaryColor}
        backgroundColor={backgroundColor}
        wallpaperUrl={selectedWallpaper}
        borderColor={borderColor}
      />

      <QrCustomizer
        primaryColor={primaryColor}
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        wallpaperUrl={selectedWallpaper}
        onPrimaryColorChange={setPrimaryColor}
        onBackgroundColorChange={setBackgroundColor}
        onBorderColorChange={setBorderColor}
        onWallpaperSelect={setSelectedWallpaper}
      />

      <ButtonWrapper>
        <ButtonGradient onClick={handleDownloadQrOnly}>
          <ButtonContent>
            <ButtonIcon src={DownIcon} alt="QR Icon" />
            Baixar apenas QR Code
          </ButtonContent>
        </ButtonGradient>

        <ButtonGradient onClick={handleDownloadWithBackground}>
          <ButtonContent>
            <ButtonIcon src={DownIcon} alt="Wallpaper Icon" />
            Baixar com fundo
          </ButtonContent>
        </ButtonGradient>
      </ButtonWrapper>
    </Container>
  );
};

export default QrCode;
